import React, {useEffect, useState} from 'react';
import {createCase, exportCases, getAllCases, getKbLocation, getKbVersion, loadCase} from '../api';
import {CaseInfo, CasesInfo, FormItem} from '../rest';
import './Home.css';
import Form from './Form';
import Card, {CardDetails} from './Card';
import {CONTINUE_CASE, NEW_CASE} from "../App";

export interface HomeProps {
  form: FormItem;
  isReplay: boolean;
  setForm: React.Dispatch<React.SetStateAction<FormItem | undefined>>
  setNextButtonTitle: React.Dispatch<React.SetStateAction<string>>
  setReplayButtonEnabled: React.Dispatch<React.SetStateAction<boolean>>
  setLoadedCase: React.Dispatch<React.SetStateAction<CaseInfo | undefined>>
  setCardDetails: React.Dispatch<React.SetStateAction<CardDetails | undefined>>
  cardDetails: CardDetails | undefined
}

function Home({
                form,
                isReplay,
                setForm,
                setNextButtonTitle,
                setReplayButtonEnabled,
                setLoadedCase,
                setCardDetails,
                cardDetails,
              }: HomeProps) {
  const [cases, setCases] = useState<CasesInfo | undefined>(undefined);


  const getCases = async (page: number) => {
    const resp = (await getAllCases(page));
    setCases(resp.payload);
  }

  const [kbVersion, setKbVersion] = useState<string>("--")
  useEffect(() => {
    const fetch = async () => {
      setKbVersion((await getKbVersion()).payload);
    }
    fetch().catch(console.error)
  })

  const [kbLocation, setKbLocation] = useState<string>("--")
  useEffect(() => {
    const fetch = async () => {
      let payload = (await getKbLocation()).payload;
      setKbLocation(payload);
    }
    fetch().catch(console.error)
  })

  useEffect(() => {
    getCases(0);
  }, [])

  const _setNextButtonTitle = React.useCallback((c: CaseInfo) => {
    if (c.isCompleted) {
      setNextButtonTitle(NEW_CASE);
    } else {
      setNextButtonTitle(CONTINUE_CASE);
    }
  }, [setNextButtonTitle]);

  useEffect(() => {

    let existingCases = cases?.cases;
    if (existingCases && existingCases.length > 0) {
      existingCases.filter(c => c.caseId === form.answers[c.caseIdName]).forEach(_setNextButtonTitle)
    } else {
      setNextButtonTitle(NEW_CASE)
    }
  }, [cases, form, setNextButtonTitle, _setNextButtonTitle])


  const renderCases = () => {
    if (cases) {
      return cases.cases.map((c, index) => {
        let creationDate = new Date(c.creationDate);
        let isCaseSelected = form.loadedFrom?.fileName === c.fileName;
        if (isCaseSelected) setReplayButtonEnabled(isCaseSelected && c.isCompleted);
        return (
          <tr className={`${isCaseSelected ? "table-primary" : ""}`} key={index} onClick={(e) => {
            e.preventDefault();
            _setNextButtonTitle(c);
            setLoadedCase(c);
            (async (c: CaseInfo) => {
              let formItem = (await loadCase(c)).payload;
              setForm(formItem);
            })(c)
          }}>
            <td>{c.caseId}</td>
            <td>{new Date(c.caseDate).toLocaleDateString()}</td>
            <td>{c.cases}</td>
            <td>{`${creationDate.toLocaleTimeString([], {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })} ${c.isCompleted ? '' : '(in Arbeit)'}`}</td>
          </tr>
        )
      })
    }
  };

  let newCaseSelected = !form.answers[form.caseInfo.caseIdName];
  return (
    <div className="home">
      <div className="patient">
        <div className="view-patient-list">
          <div className="section list-group-item-primary">
            <div className="section-header">Bestehende Fälle <a className="export-button btn btn-light"
                                                                href={exportCases + window.location.search}>Export</a>
            </div>
            <table className="table table-hove">
              <thead>
              <tr>
                <th scope="col">{form.caseInfo.caseIdName}</th>
                <th scope="col">{form.caseInfo.caseDateName}</th>
                <th scope="col" title={"Anzahl der gespeicherten Fälle"}>#</th>
                <th scope="col">Letzte Maßnahme</th>
              </tr>
              </thead>
              <tbody>
              <tr className={`${newCaseSelected ? "table-primary" : ""}`}
                  onClick={async () => {
                    setNextButtonTitle(NEW_CASE);
                    if (!newCaseSelected) setReplayButtonEnabled(newCaseSelected);
                    let homeForm = (await createCase()).payload;
                    setForm(homeForm);
                    setLoadedCase(homeForm.caseInfo);
                  }}>
                <td colSpan={4} className="font-italic text-muted">Neuer Fall</td>
              </tr>
              {renderCases()}
              </tbody>
            </table>

          </div>
          <div className="flex-centered">
            <button className="btn btn-secondary" disabled={!(cases && cases.page > 0)} onClick={() => {
              getCases(cases!.page - 1)
            }}><span>«</span>
            </button>
            <span>Seite {cases ? cases.page + 1 : 0} von {cases ? cases.maxPage : 0}</span>
            <button className="btn btn-secondary" disabled={!(cases && (cases.maxPage - 1) > cases.page)}
                    onClick={() => {
                      getCases(cases!.page + 1)
                    }}><span>»</span>
            </button>

          </div>
        </div>
        <div className="view-patient-data">
          <div className="section list-group-item-primary">
            <div className="section-header">Falldaten</div>
            <div className="view-patient">
              <Form
                readOnlyFields={form.caseInfo.isSaved ? [form.caseInfo.caseIdName, form.caseInfo.caseDateName] : []}
                form={form}
                isReplay={isReplay}
                setForm={setForm} setCardDetails={setCardDetails}/>
              <Card details={cardDetails} clear={setCardDetails}/>
            </div>
          </div>
        </div>
      </div>
      <div className="kb-info">
        <span className="kb-location">Wissensbasis: {kbLocation}</span>
        <span className="kb-version">Version: {kbVersion}</span>
      </div>
    </div>
  );
}

export default Home;